import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Select from 'react-select';
import { FaList, FaCalendarAlt } from 'react-icons/fa'; // For icons
import AddHolidayModel from './AddHolidayModel';
import { useDispatch, useSelector } from 'react-redux';
import { getHoliday, getMember, getTeams } from '../../../redux/MainAction';
import moment from 'moment';
import EditHolidayModal from './EditHolidayModal';
import { toast } from 'react-toastify';
import PaginationComponent from '../filters/PaginationComponent';

const HolidayList = () => {
  const dispatch = useDispatch();
  const Hday = useSelector((state) => state.Webtracker.holiday);

  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setEditIsModalOpen] = useState(false);

  const [showReset, setShowReset] = useState(false);
  const [dateRange, setDateRange] = useState('thisWeek');

  const [holiday, setHoliday] = useState([]);
  const [editId, setEditID] = useState('');

  const today = new Date();
  const dayOfWeek = today.getDay();
  const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  const monday = new Date(today);
  monday.setDate(today.getDate() - diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const [filters, setFilters] = useState({
    search: '',
    startDate: moment(monday).format('YYYY-MM-DD'),
    endDate: moment(sunday).format('YYYY-MM-DD'),
  });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRange(value);

    const today = new Date();
    let start, end;

    const currentDayOfWeek = today.getDay();
    const monday = new Date(today);
    monday.setDate(
      today.getDate() - (currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1)
    );
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    switch (value) {
      case 'thisWeek':
        start = monday;
        end = sunday;
        break;

      case 'last7days':
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = today;
        break;

      case 'last30days':
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = today;
        break;

      case 'custom':
        return;

      default:
        return;
    }

    setFilters((prev) => ({
      ...prev,
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    }));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleModal2 = () => {
    setEditIsModalOpen(!isEditModalOpen);
  };

  const editHandle = (id) => {
    setEditID(id);
    toggleModal2();
  };

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
      startDate: filters?.startDate,
      endDate: filters?.endDate,
    };
    dispatch(getHoliday(data));
  };

  useEffect(() => {
    getList();
  }, [page]);

  useEffect(() => {
    if (Hday && Hday?.rows) {
      setHoliday(Hday?.rows);
      setTotalPages(Math.ceil(Hday.count / itemsPerPage));
    }
  }, [Hday]);

  const handleApply = (e) => {
    e.preventDefault();
    if (filters?.startDate && filters?.endDate) {
      const startDate = moment(filters.startDate);
      const endDate = moment(filters.endDate);

      if (startDate.isAfter(endDate)) {
        toast.error('Start date cannot be greater than End date', {
          position: 'top-right',
        });
        return;
      }
    }

    const payload = {
      offset: 0,
      limit: 10,
    };

    if (filters?.search?.trim()) {
      payload.search = filters.search.trim();
    }

    if (filters?.employeeIds) {
      payload.employeeIds = [filters.employeeIds];
    }

    if (filters?.teamIds) {
      payload.teamIds = [filters.teamIds];
    }

    if (filters?.startDate) {
      payload.startDate = filters.startDate;
    }

    if (filters?.endDate) {
      payload.endDate = filters.endDate;
    }

    dispatch(getHoliday(payload));
    setShowReset(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    const payload = {
      offset: 0,
      limit: 10,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    };
    dispatch(getHoliday(payload));

    setShowReset(false);
    setFilters({
      search: '',
      startDate: moment(monday).format('YYYY-MM-DD'),
      endDate: moment(sunday).format('YYYY-MM-DD'),
    });
    setDateRange('thisWeek');
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex justify-content-between align-items-center mb-2 ml-2">
          <h5 className="text-muted"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            {/* <div style={{width:'150px'}}>
                <Select
                  options={options}
                  placeholder="Select"
                  defaultValue={options[0]}
                /> 
              </div>  */}
            <Button
              outline
              className="d-flex align-items-center"
              color="dark"
              size="md"
              onClick={toggleModal}
            >
              + Add Holiday
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {isModalOpen && (
                <AddHolidayModel open={isModalOpen} onClose={toggleModal} />
              )}
              {isEditModalOpen && (
                <EditHolidayModal
                  open={isEditModalOpen}
                  onClose={toggleModal2}
                  ID={editId}
                  filters={filters}
                />
              )}
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-10">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center ">
                        <div
                          className="d-flex justify-content-start align-items-center "
                          style={{ gap: '10px' }}
                        >
                          <div className="border rounded p-1">
                            <i className="fa fa-search text-muted ml-2 font-weight-light"></i>
                            <input
                              className="search_bar ml-2"
                              type="text"
                              placeholder="Search"
                              name="search"
                              value={filters?.search}
                              onChange={onChangeFilter}
                            />
                          </div>
                          <div className="fillSelect">
                            <select
                              className="form-control font-14"
                              value={dateRange}
                              onChange={handleDateRangeChange}
                            >
                              <option value="custom">Custom Date</option>
                              {/* <option value="today">Today</option> */}
                              <option value="thisWeek">This Week</option>
                              <option value="last7days">Last Week</option>
                              <option value="last30days">This month</option>
                              {/* <option value="last6months">Last 6 Months</option> */}
                            </select>
                          </div>
                          {dateRange === 'custom' && (
                            <div
                              className="d-flex align-items-center font-14 ml-2"
                              style={{ gap: '5px' }}
                            >
                              <input
                                type="date"
                                className="form-control font-14"
                                name="startDate"
                                value={filters?.startDate}
                                onChange={onChangeFilter}
                                max={moment().format('YYYY-MM-DD')}
                              />
                              to
                              <input
                                type="date"
                                className="form-control font-14"
                                name="endDate"
                                value={filters?.endDate}
                                onChange={onChangeFilter}
                                // max={moment().format('YYYY-MM-DD')}
                              />
                            </div>
                          )}
                          <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{ padding: '6px 14px' }}
                            size="sm"
                            color="primary"
                            onClick={handleApply}
                          >
                            <i className="ion-ios7-search font-20"></i>
                          </Button>
                          {showReset ? (
                            <Button
                              className="d-flex align-items-center justify-content-center"
                              style={{ padding: '6px 13px' }}
                              size="sm"
                              color="danger"
                              onClick={handleReset}
                            >
                              <i className="mdi mdi-close font-20"></i>
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card ">
                <div className="card-body">
                  <table
                    id="datatable"
                    className="table  dt-responsive nowrap table-vertical"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th>Day Type</th>
                        <th>Applies to</th>
                        <th>Channel</th>
                        <th>Message</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {holiday?.length > 0 ? (
                        holiday?.map((dys, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                            <td>
                              <h6 className="mt-0 m-b-5">{dys?.name}</h6>
                            </td>
                            <td className="">
                              {moment(dys?.startDate).format('MMM Do YY')}
                            </td>
                            <td className="text-white">
                              <span className="bg-success p-2 rounded">
                                {dys?.isNonWorkingDay
                                  ? 'Non-Working'
                                  : 'Working'}
                              </span>
                            </td>
                            <td>
                              <span className="border rounded-lg bg-info p-1 text-white">
                                {dys?.applicableTo}
                              </span>
                            </td>
                            <td>--</td>
                            <td>{dys?.message || '--'}</td>
                            <td>
                              <div>
                                <i
                                  className="fa fa-edit (alias) font-20 text-muted"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => editHandle(dys?.id)}
                                ></i>
                                {/* <i
                                  className="fa fa-trash-o font-20 text-danger ml-2"
                                  style={{ cursor: 'pointer' }}
                                ></i> */}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <PaginationComponent
                    count={totalPages}
                    page={page}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default HolidayList;
